module.exports = __webpack_public_path__ + "b66a525139425df77c794337cc7e3d1c.png";